export const EVENT_TIME_ZONE = "America/Toronto";

const getPartValue = (parts, type) =>
	parts.find((part) => part.type === type)?.value ?? "";

export const getEventDateParts = (dateValue) => {
	if (!dateValue) {
		return { date: "", time: "00:00" };
	}

	const eventDate = new Date(dateValue);
	if (Number.isNaN(eventDate.getTime())) {
		return { date: "", time: "00:00" };
	}

	const parts = new Intl.DateTimeFormat("en-CA", {
		timeZone: EVENT_TIME_ZONE,
		year: "numeric",
		month: "2-digit",
		day: "2-digit",
		hour: "2-digit",
		minute: "2-digit",
		hourCycle: "h23",
	}).formatToParts(eventDate);

	return {
		date: `${getPartValue(parts, "year")}-${getPartValue(
			parts,
			"month",
		)}-${getPartValue(parts, "day")}`,
		time: `${getPartValue(parts, "hour")}:${getPartValue(parts, "minute")}`,
	};
};

const getTimeZoneOffset = (dateValue) => {
	const parts = new Intl.DateTimeFormat("en-CA", {
		timeZone: EVENT_TIME_ZONE,
		year: "numeric",
		month: "2-digit",
		day: "2-digit",
		hour: "2-digit",
		minute: "2-digit",
		second: "2-digit",
		hourCycle: "h23",
	}).formatToParts(dateValue);

	const utcDate = Date.UTC(
		Number(getPartValue(parts, "year")),
		Number(getPartValue(parts, "month")) - 1,
		Number(getPartValue(parts, "day")),
		Number(getPartValue(parts, "hour")),
		Number(getPartValue(parts, "minute")),
		Number(getPartValue(parts, "second")),
	);

	return utcDate - dateValue.getTime();
};

export const buildEventDate = (date, time = "00:00") => {
	if (!date) {
		return "";
	}

	const [year, month, day] = date.split("-").map(Number);
	const [hour, minute] = time.split(":").map(Number);
	const utcGuess = new Date(Date.UTC(year, month - 1, day, hour, minute));
	const offset = getTimeZoneOffset(utcGuess);

	return new Date(utcGuess.getTime() - offset).toISOString();
};

export const formatEventDate = (dateValue) => {
	const eventDate = new Date(dateValue);
	if (Number.isNaN(eventDate.getTime())) {
		return dateValue;
	}

	return new Intl.DateTimeFormat("en-US", {
		timeZone: EVENT_TIME_ZONE,
		year: "numeric",
		month: "numeric",
		day: "numeric",
	}).format(eventDate);
};

export const formatEventDateTime = (dateValue) => {
	const eventDate = new Date(dateValue);
	if (Number.isNaN(eventDate.getTime())) {
		return dateValue;
	}

	return new Intl.DateTimeFormat("en-CA", {
		timeZone: EVENT_TIME_ZONE,
		year: "numeric",
		month: "short",
		day: "2-digit",
		hour: "numeric",
		minute: "2-digit",
		timeZoneName: "short",
	}).format(eventDate);
};
